import Grid from 'components/Grid'
import GridsNavigation from 'components/Grid/components/GridsSidebar'
import useSubject from 'pages/subiect/useSubject'
import { handleGetGridDifficulty } from 'utils'

const CreatedSubject = ({ createdSubject }) => {
  const {
    currentGridIndex,
    handleCurrentGrid,
    handlePrevGrid,
    handleNextGrid,
    height,
    setHeight,
  } = useSubject(true)

  return (
    <div className="flex justify-center p-0">
      <Grid
        setHeight={setHeight}
        height={height}
        difficulty={handleGetGridDifficulty(
          createdSubject[currentGridIndex]?.difficulty,
        )}
        gridTags={createdSubject[currentGridIndex]?.capitole}
        gridsFromSubject={createdSubject}
        currentGridIndex={currentGridIndex}
        currentGridId={createdSubject[currentGridIndex]?.id}
        isMultipleChoice={() => {
          return false
        }}
        isSubject
        started={true}
        currentGrila={createdSubject[currentGridIndex]?.json}
        handleNextGrid={handleNextGrid}
        handlePrevGrid={handlePrevGrid}
        handleCurrentGrid={handleCurrentGrid}
      />
      <GridsNavigation
        currentGridIndex={currentGridIndex}
        handleCurrentGrid={handleCurrentGrid}
        gridsFromSubject={createdSubject}
        create={true}
      />
    </div>
  )
}

export default CreatedSubject
